import Utils from '@/common/utils/utils';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import Constant from '../../../common/constant/Constant';
import { getPanelType } from '../handler/CreateTicketCommonHandler';

export const DialogConfirmCancelCreateTicket = props => {
    const { onClickSaveDraft, isDraftMode, handleSubmitSentDraft, isDisableButtonSend, isDuplicate } = props;
    let msgDisplay = I18n.get('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE');
    // let labelConfirm = I18n.get('COMBTN011');
    let labelCancel = I18n.get('CM-BUTTON-OK');
    let labelClose = I18n.get('CM-BUTTON-CANCEL');

    // if (isDraftMode && !isDuplicate) {
    //     msgDisplay = props.createTicketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT
    //         ? I18n.get('USER04MSG018')
    //         : I18n.get('USER04MSG019');
    //     labelConfirm = I18n.get('USER04BTN001');
    //     labelCancel = I18n.get('USER04BTN023');
    // }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmCancelCreateTicket(false);
    };

    const onHandlerCancelCreateTicket = () => {
        props.setIsConfirmCancelCreateTicket(false);
        if(props?.setHandleStatus) {
            props?.setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
        }
        props.closePanelTab({
            event: null,
            panelType: getPanelType(props.panelList, props.panelId),
            panelId: props.panelId,
            tabId: props.tabId
        });
    };

    // const onHandlerConfirmSaveDraft = () => {
    //     props.setIsConfirmCancelCreateTicket(false);
    //     if (isDraftMode && handleSubmitSentDraft) {
    //         if(props.setSubmitTime){
    //             props.setSubmitTime(new Date().getTime())
    //         }
    //         handleSubmitSentDraft();
    //     } else {
    //         onClickSaveDraft();
    //     }
    // };

    return (
        <Dialog
            open={props.isConfirmCancelCreateTicket}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">{msgDisplay}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onHandlerCancelCreateTicket}
                >
                    {labelCancel}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {labelClose}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
